import {CommonMessages} from '../common.messages';

export const FeedSubscriptionLogMessages = {
    GetFeedSubscriptionLogFailed: {
        key: 'GetFeedSubscriptionLogFailed',
        message: 'Error while communication with the server. Unable to get feed subscription logs.'
    },
    GetFeedSubscriptionLogNoData: {
        key: 'GetFeedSubscriptionLogNoData',
        message: 'No feed subscription logs.'
    },
    GetBundleDataFailed: {
        key: 'GetBundleDataFailed',
        message: 'Error while communication with the server. Unable to get feed bundles.'
    },
    GetUserAccountsFailed: {
        key: 'GetUserAccountsFailed',
        message: 'Error while communication with the server. Unable to get accounts.'
    },
    GetPlatformFeTradingPlatformFailed: {
        key: 'GetPlatformFeTradingPlatformFailed',
        message: 'Error while communication with the server. Unable to get platform frontends/trading platforms.'
    },
    GetFeedSubscriptionLogNoBundleData: {
        key: 'GetFeedSubscriptionLogNoBundleData',
        message: 'No feed bundles.'
    },
    ExportFeedSubscriptionLogFailed: {
        key: 'ExportFeedSubscriptionLogFailed',
        message: 'Error while communication with the server. Unable to export event history.'
    },
    ...CommonMessages
};
